import { useState, useCallback } from 'react';

export function useDrawerSelection<T>(value: T, onChange?: (v: T) => void) {
  const [localSelection, setLocalSelection] = useState<T>(value);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) setLocalSelection(value);
    },
    [value],
  );

  const handleSelect = useCallback(
    (newValue: T) => setLocalSelection(newValue),
    [],
  );

  const handleConfirm = useCallback(
    () => (onChange ? onChange(localSelection) : ''),
    [localSelection, onChange],
  );

  return {
    localSelection,
    setLocalSelection,
    handleOpenChange,
    handleSelect,
    handleConfirm,
  };
}
